<div class="container-fluid py-3">
  <!-- Page header -->
  <div class="d-flex align-items-center mb-4">
    <i class="fas fa-users-class text-primary fs-3 me-3"></i>
    <div>
      <h4 class="mb-0 fw-bold">{{ 'FOLLOWING.TITLE' | translate }}</h4>
      <small class="text-muted">{{ 'FOLLOWING.SUBTITLE' | translate }}</small>
    </div>
  </div>

  <!-- Sessions datatable -->
  <app-card [customClasses]="'p-3 bg-dashboard-card'">
    <app-student-sessions-tab />
  </app-card>
</div>
